import React from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';

const ConditionalNavbar = () => {
  const location = useLocation();
  
  // Pages that SHOULD show the navbar (public pages without sidebar)
  const showNavbarPages = [];
  
  // Check if current path starts with any of the allowed paths
  const shouldShowNavbar = showNavbarPages.some(path => 
    location.pathname.startsWith(path)
  );
  
  // Only show navbar on specific public pages
  if (shouldShowNavbar) {
    return <Navbar />;
  }
  
  return null;
};

export default ConditionalNavbar; 